module.exports = __webpack_public_path__ + "static/media/doctorPortal.a93aa232.png";